export const deviationTypeToLocaleMap = {
  deviationCrew: 'Bemanningsavvikelse',
  deviationVehicle: 'Fordonsavvikelse',
  deviationCancel: 'Inställt tåg',
  deviationDelay: 'Försening',
  deviationDisruption: 'Störningshantering',
}
